import apiClient from 'utilities/apiClient';

export const changePassword = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.printLable}/${url}`, payload, true);
};
